import React, { useContext, useEffect } from 'react';
import styles from './GamesReport.module.scss';
import cx from 'classnames';
import { EmptyState, BoxSuccess } from 'esa-ui-library';
import { reportsPages, useStore } from '../../../common';
import {
	Header,
	PageAuth,
	PageContainer,
	Sidebar,
	SideMenu,
	Page,
	PageHeader,
	GlobalAlert,
	Filters,
} from '../../components';
import { PERMISSIONS } from '../../constants';
import { AuthContext } from '../../../logic';
import {
	// AgregatorsFilter,
	CategoriesFilter,
	CountriesFilter,
	DateFilter,
	DevicesFilter,
	GamesFilter,
	PartnersFilter,
	PlayerCurrencyFilter,
	ProvidersFilter,
	VipLevelsFilter,
} from '../../components/Filters/components';
import { find, isEmpty } from 'lodash';
import { GamesReportTable } from './Table/GamesReportTable';
// import { ReportTemplates } from './ReportTemplates/ReportTemplates';
import { getPreselectedAggregator } from './GamesReport.helper';
import { RealMoneyFilter } from '../../components/Filters/components/RealMoneyFilter/RealMoneyFilter';

const GamesReport = (): JSX.Element => {
	const [state, dispatch] = useStore();
	const { reports, reportsLoading, filters, selectedTemplate, gamblingReportList } = state;
	const { user, token } = useContext(AuthContext);
	const isItaly = process.env.REACT_APP_SITE_TITLE?.includes('Italy');
	const providerId = process.env.REACT_APP_SITE_TITLE?.includes('Italy') ? '2003' : '2000';
	const isFilterValid = () => {
		const aggregatorFilter = find(filters, ['name', 'aggregators']);
		const dateFilter = find(filters, ['name', 'start_date']);
		return aggregatorFilter?.value && dateFilter?.value;
	};

	useEffect(() => {
		dispatch('PARTNERS_INIT', user);
		dispatch('FILTERS_INIT', {
			token,
			filters: [
				'gamblingReportList',
				'games',
				'affiliate',
				'currencies',
				'countries',
				'providers',
				'devices',
				'player_levels',
				'gameCategories',
			],
		});
	}, []);

	useEffect(() => {
		if (!isEmpty(selectedTemplate)) {
			dispatch('LOAD_TEMPLATE_DATA', { token, id: selectedTemplate.value });
		} else {
			const aggregator = getPreselectedAggregator(gamblingReportList);
			dispatch('UPDATE_FILTERS', [
				{ name: 'aggregators', value: aggregator },
				{ name: 'money_type', value: '0' },
				{ name: 'game_provider_ids', value: providerId },
			]);
		}
	}, [selectedTemplate]);

	return (
		<>
			<Header dataId='header' />
			<PageAuth permission={PERMISSIONS.canViewOwnDetails}>
				<PageContainer>
					<Sidebar dataId='admin-sidebar'>
						<SideMenu options={reportsPages} title='Reports' />
					</Sidebar>
					<Page>
						<PageHeader title='Games Report' className={styles.Header}>
							{/*<ReportTemplates />*/}
						</PageHeader>
						<section className={styles.PageContent}>
							<Filters>
								{/*<div>*/}
								{/*	<AgregatorsFilter />*/}
								{/*</div>*/}
								<div className={cx(styles.Filters, { [styles.NoEvent]: reportsLoading })}>
									<PartnersFilter />
									{/* <AffiliatesFilter /> */}
									<CategoriesFilter />
									<ProvidersFilter />
									<GamesFilter />
									<DevicesFilter />
									<CountriesFilter />
									<PlayerCurrencyFilter />
									<RealMoneyFilter filterName='money_type' />
									{isItaly && <VipLevelsFilter />}
									<DateFilter fullWidth />
								</div>
							</Filters>
							{!isFilterValid() && !reportsLoading ? (
								<div className={styles.EmptyBox}>
									<EmptyState
										title='Please select a Date Range to retrieve results'
										icon={<BoxSuccess />}
										dataId='empty-state-component'
									/>
								</div>
							) : (
								<GamesReportTable isLoading={reportsLoading} data={reports} />
							)}
						</section>
					</Page>
				</PageContainer>
				<GlobalAlert />
			</PageAuth>
		</>
	);
};

export { GamesReport };
